export default "__VITE_ASSET__lS337Cle__"